import { createContext } from 'react'

import { TipoDaBarraSuperior } from './barra-superior.interface'

export const ContextoDaBarraSuperior = createContext<TipoDaBarraSuperior>(null)
